import cn from 'classnames';

import ArticleCard, { ArticleCardProps } from '../ArticleCard';

import styles from './ArticleGrid.module.scss';

export type ArticleGridProps = {
  className?: string;
  items: Array<ArticleCardProps>;
};

const ArticleGrid = (props: ArticleGridProps): JSX.Element => {
  const { items, className } = props;

  return (
    <ul className={cn(styles.list, className)}>
      {items.map((item) => (
        <li key={JSON.stringify(item)} className={styles['list-item']}>
          <ArticleCard className={styles.card} {...item} />
        </li>
      ))}
    </ul>
  );
};

export default ArticleGrid;
